module.exports = __webpack_public_path__ + "static/media/profile.56902ef6.svg";